module.exports = "/images/PAR_portada.jpg?4a061d3799474d9a20bdea89854e1419";